import { DocumentScannerOutlined } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { useProofPaymentStore } from 'modules/orders/components'
import { ActionsItemProps } from './actions'

export const ProofPayment = ({ order, disabled }: ActionsItemProps) => {
  const setIsProofPaymentModalOpen = useProofPaymentStore.useSetModalOpen()
  const setProposalId = useProofPaymentStore.useSetProposalId()

  const handleClick = () => {
    setIsProofPaymentModalOpen(true)
    setProposalId(order?.proposalId)
  }

  return (
    <MenuItem onClick={handleClick} disabled={disabled}>
      <DocumentScannerOutlined />
      Enviar Comprovante de Pagamento
    </MenuItem>
  )
}
